export const STATUSES = ['new', 'active', 'paused', 'paused', 'paused', 'disable', 'closed'];
export const TYPES = [
  'buy',
  'sell',
  'balance',
  'credit',
  'additional_charge',
  'correction',
  'bonus',
  'fee',
  'dividend',
  'interest',
  'cancelled',
  'cancelled',
  'periodical_commission',
];
export const REWARD_TYPES = {
  Shareofprofit: '% from Profit',
  Highwatermark: 'High water mark',
};

export const REWARD_TYPES_TR_KEYS = {
  Shareofprofit: 'investShareOfProfit',
  Highwatermark: 'investHighWaterMark',
};

export const COPY_TYPES_TR_KEYS = ['investOpenOnlyNewDeals', 'investOpenCurrentDeals'];

export const FREQUENCY_TR_KEYS = {
  Monthly: 'justMonthly',
  Weekly: 'justWeekly',
};

// Copy Trading allocation settings
export const ALLOCATION_METHOD_FIXED = 0; // Ratio
export const ALLOCATION_METHOD_EQUITY = 1; // Equity
export const ALLOCATION_METHOD_BY_EQUITY = 2; // Equity ratio
export const ALLOCATION_METHOD_BALANCE = 3; // Balance ratio
export const ALLOCATION_PERCENT_DEFAULT = 100;
export const ALLOCATION_METHODS = [ALLOCATION_METHOD_FIXED, ALLOCATION_METHOD_BY_EQUITY];
export const ALLOCATION_PERCENT_MIN = 0.1;
export const ALLOCATION_PERCENT_MAX = 1000;
export const ALLOCATION_PERCENT_STEP = 10;

// Strategy types
export const STRATEGY_TYPE_LABELS = ['MAM', 'PAMM', 'Social trading'];
export const STRATEGY_TYPE_OPTIONS = STRATEGY_TYPE_LABELS.map((label, value) => ({ value: String(value), label }));
